export * from './rolesNPermissions';
export * from './adminUsers';
export * from './organisations';
export * from './members';
export * from './avatarUpload';

export const enum PRODUCT_COURSE_MAPPING {
  productCourseMapping = '/product-course-mapping',
  bulkUpload = '/product-course-upload',
}
export const enum ESIS_JOBS {
  esisLogs = '/esis-logs',
  esisLogsDetail = '/esis-logs/:esisJobId',
}
